import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "organisationName",
  class: "form-label"
}, "Name", -1)
const _hoisted_4 = ["readonly"]
const _hoisted_5 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_6 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Update Organisation ")

import { Ref, ref, watch } from "vue";
import { getFunctions } from "firebase/functions";
import { ValidationError, validationMessage } from "@/model/validation-error";
import ModalView from "@/components/ModalView.vue";
import { ApiService } from "@/api-service";
import { Organisation } from "@/model/organisation";


export default /*#__PURE__*/_defineComponent({
  props: {
    organisation: null,
    isVisible: { type: Boolean }
  },
  emits: ["hide-modal"],
  setup(__props: any, { emit }) {

const props = __props as {
  organisation: Organisation;
  isVisible: boolean;
}

let organisationName: Ref<string | null> = ref(null);
let organisationNameError: Ref<string | null> = ref(null);
let loading: Ref<boolean> = ref(false);



const apiService = new ApiService(getFunctions());



async function editOrganisation() {
  loading.value = true;
  await apiService
    .editOrganisation(props.organisation.id, organisationName.value)
    .then(() => {
      emit("hide-modal");
    })
    .catch((error) => {
      console.log("editOrganisation failed", error);
      if (error.details) {
        let validationErrors = error.details as ValidationError[];
        for (let validationError of validationErrors) {
          switch (validationError.field) {
            case "name": {
              organisationNameError.value = validationMessage(
                validationError.reason
              );
              break;
            }
          }
        }
      }
    });

  loading.value = false;
}

watch(
  () => props.isVisible,
  (visible: boolean) => {
    if (visible) {
      organisationName.value = props.organisation.name;
    }
  }
);

watch(
  () => organisationName.value,
  () => {
    organisationNameError.value = null;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalView, {
    "is-visible": __props.isVisible,
    onHideModal: _cache[1] || (_cache[1] = ($event: any) => (emit('hide-modal')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn-close", { disabled: _unref(loading) }]),
        "data-bs-dismiss": "modal",
        "aria-label": "Close"
      }, null, 2)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _unref(organisationNameError) }]),
            id: "organisationName",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(organisationName) ? (organisationName).value = $event : organisationName = $event)),
            readonly: _unref(loading)
          }, null, 10, _hoisted_4), [
            [_vModelText, _unref(organisationName)]
          ]),
          (_unref(organisationNameError) != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(organisationNameError)), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn btn-primary", { disabled: _unref(loading) }]),
        onClick: editOrganisation
      }, [
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("span", _hoisted_6))
          : _createCommentVNode("", true),
        _hoisted_7
      ], 2)
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})